import translationKeys from '@translationKeys'

import { AlertFrequencyType } from './types'

export const ALERT_FREQUENCY_TO_LABEL_MAP = {
  [AlertFrequencyType.NO_NOTIFICATION]: translationKeys.ALERT_FREQUENCY_NO_NOTIFICATION,
  [AlertFrequencyType.DAILY]: translationKeys.ALERT_FREQUENCY_DAILY,
  [AlertFrequencyType.WEEKLY]: translationKeys.ALERT_FREQUENCY_WEEKLY,
}
